export const commentList = {
  title: '评论列表',
  allStatus: '全部状态',
  resolve: '已解决',
  notResolve: '未解决',
  close: '关闭',
  loading: '加载中',
  all: '所有人',
  allMember: '全部成员',
  currentDoc: '当前文档',
  currentPage: '当前页面',
  cancel: '取消',
  user: '提出人：',
  time: '提出时间：',
  attachment: '附件({adjunct})',
  reply: '回复({answer})'
}
